<cx-split-view [hideMode]="false">
  @if (uigStructure$ | async; as structure) {
    @if (listData$ | async; as data) {
      <cx-view class="list">
        <div class="header">
          <div class="title">
            <h3>
              {{
              uigViewType + '.header' | cxTranslate: { count: getListCount(data) }
              }}
              <button
                [cxPopover]="listHint"
              [cxPopoverOptions]="{
                placement: 'auto',
                class: 'hint-popover',
                appendToBody: true,
                displayCloseButton: true
              }"
                >
              </button>
            </h3>
          </div>
          <div class="actions">
            @if (data.pagination?.sort) {
              <ng-select
                name="sort"
                class="sort type-sort"
                [searchable]="false"
                [clearable]="false"
                (change)="sort(data.pagination)"
                [tabIndex]="0"
                [(ngModel)]="sortCode"
            [attr.aria-label]="
              (sortCode
                ? structure.type + '.sort.' + sortCode
                : structure.type + '.sortBy'
              ) | cxTranslate
            "
                >
                @for (sort of data.sorts; track sort) {
                  <ng-option [value]="sort.code">
                    {{ structure.type + '.sort.' + sort.code | cxTranslate }}
                  </ng-option>
                }
              </ng-select>
            }
            <ng-content select="[actions]"></ng-content>
            <a
              class="button btn-secondary create"
              [routerLink]="{ cxRoute: structure.type + 'Create' } | cxUrl"
              routerLinkActive="disabled"
              >
              {{ 'organization.add' | cxTranslate }}
            </a>
          </div>
        </div>
        @if (data.values?.length > 0) {
          <cx-table
            [structure]="structure"
            [data]="data.values"
            [i18nRoot]="domainType"
            [currentItem]="{ property: key, value: currentKey$ | async }"
            (launch)="launchItem($event)"
            [cxFocus]="{ trap: 'both' }"
            >
          </cx-table>
        } @else {
          <p class="instruction is-empty">
            {{ 'organization.messages.emptyList' | cxTranslate }}
          </p>
        }
        <div class="footer">
          <cx-pagination
            [pagination]="data.pagination"
            (viewPageEvent)="browse(data.pagination, $event)"
          ></cx-pagination>
        </div>
      </cx-view>
    }
    <!-- nested split views are rendered inside child routes -->
    <router-outlet></router-outlet>
  }
</cx-split-view>


<ng-template #listHint>
  <p>
    {{ uigViewType + '.hint' | cxTranslate }}
  </p>
</ng-template>
